import React, { useState } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import TableArbitre from './tableauArbitre';
import TableContact from './tableauContact';

function TableAdmin(props) {
    const [donnée_equipe] = useState(props.userData.user.equipe);
    const [donnée_coach] = useState(props.userData.user.coach);
    const [donnée_joueur] = useState(props.userData.user.joueur);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [response, setResponse] = useState(false);
    const [supprimer, setSupprimer] = useState(false);
    const [equipe_supp, setEquipe_supp] = useState(null);
    const [nom_championnat, setNom_championat] = useState("");
    const [region, setRegion] = useState("");
    const [categorie, setCategorie] = useState("");
    const [urlClassement, SetUrlClassement] = useState("");
    const [urlMatch, SetUrlMatch] = useState("");
    const apiUrl = process.env.REACT_APP_API_URL;

    console.log(localStorage)


    const handleSubmit = async (e, action, equipeId) => {
        e.preventDefault();
        setIsLoading(true);
        if (action === "Rejeter") {
            setSupprimer(false);
        } else if (!nom_championnat || !region || !categorie || !urlClassement || !urlMatch) {
            setIsLoading(false);
            return;
        } else {
            setSupprimer(false);
        }

        try {
            const response = await axios.post(`${apiUrl}/verification/club`, {
                verification: action,
                id_equipe: equipeId,
                nom_championnat: nom_championnat,
                categorie: categorie,
                region: region,
                urlClassement: urlClassement,
                urlMatch: urlMatch
            }, {
                withCredentials: true
            });
            setResponse(response.data);
            setEquipe_supp([]);
            setIsLoading(false);
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } catch (error) {
            setEquipe_supp([]);
            if (error.response) {
                setError(error.response.data.message);
            } else {
                setError(true);
            }
            setIsLoading(false);
        }
    }

    if (isLoading) {
        return (
            <div className="centered-content">
                <img src="/img/logo.png" alt="Logo" className="centered-logo" />
                <br />
                <span className="loader"></span>
            </div>
        );
    }

    return (
        <>
            {error &&
                <div id="alert-message" className="alert4">
                    <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                </div>
            }
            {response &&
                <>
                    <div id="alert-message" className="alert3">
                        <strong>Vérification réalisée avec succès !</strong> {response.message}<span id="alert-text"></span>
                    </div>
                </>
            }
            {supprimer && (
                <Modal show={supprimer} onHide={() => { setSupprimer(false); setEquipe_supp([]) }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmation de l'action</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Voulez-vous vraiment {equipe_supp[0].toLowerCase()} l'équipe {equipe_supp[2]} ?</p>
                        {equipe_supp[0] === "Accepter" && (
                            <>
                                <p>Veuillez fournir les détails du championnat de l'équipe :</p>
                                <Form>
                                    <Form.Group controlId="formNomChampionnat">
                                        <Form.Label>Nom du championnat</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={nom_championnat}
                                            onChange={(e) => setNom_championat(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formRegion">
                                        <Form.Label>Région du championnat</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={region}
                                            onChange={(e) => setRegion(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formCategorie">
                                        <Form.Label>Catégorie</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={categorie}
                                            onChange={(e) => setCategorie(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formUrlMatch">
                                        <Form.Label>URL pour les matchs</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={urlMatch}
                                            onChange={(e) => SetUrlMatch(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formUrlClassement">
                                        <Form.Label>URL pour le classement</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={urlClassement}
                                            onChange={(e) => SetUrlClassement(e.target.value)}
                                        />
                                    </Form.Group>
                                </Form>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => { setSupprimer(false); setEquipe_supp([]) }}>
                            Annuler
                        </Button>
                        <Button variant="primary" style={{ backgroundColor: "#00E676", borderColor: '#00E676' }} onClick={(e) => { handleSubmit(e, equipe_supp[0], equipe_supp[1]) }}>
                            {equipe_supp[0] === "Accepter" ? "Accepter" : "Supprimer"}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

    <h2 className="admin_" >Equipes</h2>
    <table id='admin'>
        <thead>
            <tr>
            <th scope="col">id</th>
            <th scope="col">Equipe</th>
            <th scope="col">Catégorie</th>
            <th scope="col">Adresse</th>
            <th scope="col">Fichier</th>
            <th scope="col">Vérification</th>
            </tr>
        </thead>
        <tbody>
            {donnée_equipe && donnée_equipe.results && donnée_equipe.results.map((item, index) => (
                <tr key={index}>
                    <td data-label="id">{item.id_equipe}</td>
                    <td data-label="Equipe">{item.nom}</td>
                    <td data-label="Catégorie">{item.categorie}</td>
                    <td data-label="Adresse">{item.adresse}</td>
                    <td data-label="Fichier"><a href={`${apiUrl}/telecharger/fichier/equipe/${item.fichier_verif}`} target="_blank" rel="noreferrer">{item.fichier_verif}</a></td>
                    {item.verifi_certification === "false" ? (
                      <td id="verif_admin" data-label="Vérification"><button onClick={(e) => {setSupprimer(true);setEquipe_supp(["Accepter",item.id_equipe,item.nom]);}}>  Accepter  </button>   <button onClick={(e) => {setSupprimer(true);setEquipe_supp(["Rejeter",item.id_equipe,item.nom])}}>  Rejeter  </button></td>
                    ) : (

                        <td id="verif_admin" data-label="Vérification">Club vérifier</td>
                    )}
                    
                </tr>
            ))}
        </tbody>

    </table>
    <h2 className="admin_">Coachs</h2>
    <table id='admin'>
        <thead>
            <tr>
            <th scope="col">id</th>
            <th scope="col">Nom</th>
            <th scope="col">Prenom</th>
            <th scope="col">Email</th>
            <th scope="col">Numéro de téléphone</th>
            <th scope="col">Vérification de l'email</th>
            <th scope="col">Equipe</th>
            </tr>
        </thead>
        <tbody>
            {donnée_coach && donnée_coach.results && donnée_coach.results.map((item, index) => (
                <tr key={index}>
                    <td data-label="id">{item.id_coach}</td>
                    <td data-label="nom">{item.nom_coach}</td>
                    <td data-label="prenom">{item.prenom}</td>
                    <td data-label="email">{item.email}</td>
                    <td data-label="téléphone">{item.contact}</td>
                    <td data-label="Verification de l'email">{item.verif_email}</td>
                    <td data-label="equipe">{item.nom_equipe}</td>
                </tr>
            ))}
        </tbody>

    </table>
    <h2 className="admin_">Joueurs</h2>
    <table id='admin'>
        <thead>
            <tr>
            <th scope="col">id</th>
            <th scope="col">Nom</th>
            <th scope="col">Prenom</th>
            <th scope="col">Email</th>
            <th scope="col">Numéro de téléphone</th>
            <th scope="col">Compte créer</th>
            <th scope="col">Equipe</th>
            </tr>
        </thead>
        <tbody>
            {donnée_joueur && donnée_joueur.results && donnée_joueur.results.map((item, index) => (
                <tr key={index}>
                    <td data-label="id">{item.id_joueur}</td>
                    <td data-label="Nom">{item.nom_joueur}</td>
                    <td data-label="Prenom">{item.prenom}</td>
                    <td data-label="Email">{item.email}</td>
                    <td data-label="Numéro de téléphone">{item.contact}</td>
                    <td data-label="Compte créer">{item.compte_ok}</td>
                    <td data-label="equipe">{item.nom_equipe}</td>
                </tr>
            ))}
        </tbody>
    </table>
    <TableArbitre userData={props.userData} />
    <TableContact userData={props.userData} />
        <br></br>
        <br></br>
        <br></br>
   </> 

    );
}

export default TableAdmin;